import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import ProcessDevice from './ProcessDevice';
import OurProductsSection from "./OurProductsSection"

import '../styles/MedicalTechnology.css';

import MedicalTechnologyImg from '../assets/MedicalTechnologyImg.png'

const MedicalTechnology = () => {

  return (
    <div className="MedicalTechnology">
      <Header />

      {/* Hero Banner Section */}
      {/* <section className="hero-banner7">
        <div className="hero-content">
          <h1>AUTOMOBILES AND PARTS</h1>
          <div className="breadcrumb">
            <span><a href="/" style={{ color: "#ACECFC" }}>Home</a></span> ⪢ <span>Automobiles And Parts</span>
          </div>
        </div>
      </section> */}

<section className="MedicalTechnology-hero-clean">
  <div className="hero-text">
    <h1>Medical Technology</h1>
    <p>
			We offer you a full-range of products and system solutions tailored to individual tasks for laboratory automation, medical technology and hospital logistics.
    </p>
  </div>
  <br/>
  <div className="hero-image">
    <img src={MedicalTechnologyImg} alt="Medical Technology" />
  </div>
</section>


<ProcessDevice />
<OurProductsSection />

      <Footer />
    </div>
  );
};
export default MedicalTechnology;